export enum BannerVariant {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
}
